module.exports = __webpack_public_path__ + "img/m-line-short.6fa45c29.svg";